import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const OutletContainer = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;
